<template>
  <button
    :disabled="disabled"
    class="tw-flex tw-justify-center tw-items-center tw-bg-transparent tw-rounded-full tw-h-10 tw-w-10 disabled:tw-opacity-30 disabled:hover:tw-cursor-not-allowed"
    @click="(e) => $emit('click', e)"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
}
</script>
